import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { keyframes } from '@emotion/core';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import styled from '@emotion/styled';
import { fontSizes, colors, defaultFontFamily, } from '@modernhealth/vital-foundation';
import { ColorVariant } from './ColorVariant';
var LabelSize;
(function (LabelSize) {
    LabelSize["Small"] = "small";
    LabelSize["Medium"] = "medium";
})(LabelSize || (LabelSize = {}));
const shrinkIn = keyframes `
    0% {
        transform: translate(13px,26px) scale(1.3);
    }
    100% {
        transform: translate(0,0) scale(1);
    }`;
const shrinkOut = keyframes `
    0% {
        transform: translate(-13px,-26px) scale(0.75);
    }
    100% {
        transform: translate(0,0) scale(1);
    }`;
const Label = styled.label(({ variant, size }) => {
    let labelColor = '';
    switch (variant) {
        case ColorVariant.Error:
            labelColor = colors.red55;
            break;
        case ColorVariant.Active:
            labelColor = colors.violet55;
            break;
        default:
            labelColor = colors.gray55;
    }
    return {
        color: labelColor,
        fontSize: size === LabelSize.Small ? fontSizes.small : fontSizes.medium,
        fontFamily: defaultFontFamily,
    };
});
const Container = styled.div({
    position: 'relative',
    zIndex: 9,
});
const LabelContainer = styled.div(({ active, fixed, size, rightPadding = '0' }) => {
    return {
        position: 'absolute',
        left: '8px',
        // Extend the "cover" to the entire field unless it is active or fixed.
        // Add an optional 'rightPadding' for fields like select and date picker.
        right: fixed || active ? undefined : `calc(${rightPadding} + 8px)`,
        top: size === LabelSize.Small ? '-8px' : '16px',
        backgroundColor: colors.white,
        paddingLeft: '4px',
        paddingRight: '4px',
        // eslint-disable-next-line no-nested-ternary
        animationName: fixed ? '' : active ? `${shrinkIn}` : `${shrinkOut}`,
        animationDuration: '200ms',
        pointerEvents: 'none',
    };
});
export const OutlinedLabel = ({ id, filled, floatingLabelFixed, active, label, variant, rightPadding, }) => {
    const size = floatingLabelFixed || filled || active ? LabelSize.Small : LabelSize.Medium;
    const fixed = floatingLabelFixed || filled;
    return (_jsx(Container, { id: id, children: _jsx(LabelContainer, { rightPadding: rightPadding, active: active, fixed: fixed, size: size, children: _jsx(Label, { size: size, variant: variant, children: label }) }) }));
};
